<template>
  <div>
    <h1>Readme</h1>

    <v-row>
      <v-col cols="12" xs="12">
        <v-card width="100%">
          <v-card-text>
            <mdfile></mdfile>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import mdfile from "@/../README.md";

export default {
  name: "Readme",
  components: {
    mdfile
  },
  mixins: [uiView],
  created() {},
  props: {},
  watch: {},
  computed: {},
  data: () => ({}),
  created() {},
  methods: {},
};
</script>
<style lang="scss">
</style>
